"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var adjustUrlParams_1 = __importDefault(require("./adjustUrlParams"));
var removeParamsFromUrl = function (url, paramsToRemove) {
    return adjustUrlParams_1.default(function (currentParams) { return lodash_1.omit(currentParams, paramsToRemove !== null && paramsToRemove !== void 0 ? paramsToRemove : []); }, url);
};
exports.default = removeParamsFromUrl;
